// noinspection DuplicatedCode
import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Colors } from "../../../assets/Colors";
import { DynamicTablev3 } from "../../../components/tablecard/DynamicTable";
import { Card, CardBody } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { useForm } from "../../../components/isRequired";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import { toast } from "react-toastify";
import { maxPageGlobal } from "../../../assets/config";
import { GetBody, GetTh } from "../../../components/tablecard/TableEtc";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ReportPurchaseOrder = ({}) => {
  let initialState = {
    Bulan: new Date(),
    BisnisUnitID: "U0002",
  };

  const validations = [];

  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const [data, setData] = useState(null);
  const [dataUpkeep, setDataUpkeep] = useState(null);
  const mutationData = useMutation((param) =>
    fetchGet(
      "Procurement/Report/PurchaseOrder/" +
        param.BisnisUnitID +
        "/" +
        param.Bulan +
        "/" +
        param.Tahun +
        "/" +
        param.Bagian +
        "/" +
        param.Approved +
        "/" +
        param.search
    )
  );
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "MSR",
    BisnisUnitID: "U0002",
    Bagian: "B",
    Approved: "1",
    Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
    Tahun: new Date(values.Bulan).getFullYear().toString(),
  });
  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const header = [
    { name: "No. MSR", key: "PurchaseRequisitionID" },
    { name: "Tanggal MSR ", key: "DatePR", modifiers: "Date" },
    { name: "Keterangan", key: "Remarks", modifiers: "Text" },
    { name: "Bagian", key: "NamaBagian", modifiers: "Text" },
    { name: "Pembuat ", key: "NamaKaryawan", modifiers: "Text" },
    { name: "Pemohon", key: "Requester", modifiers: "Text" },
    { name: "Tipe", key: "Tipe", modifiers: "Text" },
    { name: "Status", key: "STATUS", modifiers: "Text" },
    { name: "Action", key: "LihatPR", modifiers: "LihatPR" },
  ];

  function substructHour(date, hours) {
    const dateCopy = new Date(date);
    dateCopy.setHours(dateCopy.getHours() - hours);
    return dateCopy;
  }

  const getApprovals = (data, urutan) => {
    let date = data
      .filter((datafilter) => datafilter.Urutan === urutan)
      .map((approvals) => approvals.Tanggal)[0];

    let dateformat = new Date(substructHour(date, 7)).toLocaleTimeString(
      "en-GB",
      {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
      }
    );
    return dateformat == "Invalid Date" ? "" : dateformat;
  };

  const filterData = (event) => {
    setSearch(event.target.value);
  };
  const filterApi = () => {
    let bagian = "B";
    if (values.Bagian) bagian = values.Bagian;

    let StatusReportPOID = "1";
    if (values.StatusReportPOID) StatusReportPOID = values.StatusReportPOID;
    setParam({
      start: start,
      count: count,
      search: search,
      BisnisUnitID: values.BisnisUnitID,
      Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: new Date(values.Bulan).getFullYear().toString(),
      Bagian: bagian,
      Approved: StatusReportPOID,
    });
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                  <div className={"w-1/5"}>
                    <HrdInputGenerator
                      type={"BisnisUnit"}
                      name={"BisnisUnitID"}
                      title={"BisnisUnit"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/6"}>
                    <HrdInputGenerator
                      type={"bulan"}
                      name={"Bulan"}
                      title={"Bulan"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/5"}>
                    <HrdInputGenerator
                      type={"Bagian"}
                      name={"Bagian"}
                      title={"Bagian"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/5"}>
                    <HrdInputGenerator
                      type={"StatusReportPO"}
                      name={"StatusReportPOID"}
                      title={"Status"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/6"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>

                    <button
                      type="button"
                      onClick={filterApi}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 px-7 py-2 text-center mr-2 mb-2 "
                    >
                      Buka
                    </button>
                  </div>
                  <div className={"w-1/4 ml-3 "}>
                    <DownloadTableExcel
                      filename="Laporan PO"
                      sheet="PO"
                      currentTableRef={tableRef.current}
                    >
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-5">
                        Download Excels
                      </label>
                      <div className="inline-block relative w-full  ">
                        <button className="appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500">
                          Print
                        </button>
                      </div>
                    </DownloadTableExcel>
                  </div>
                </div>

                <div className="flex flex-col items-center content-center ">
                  <CardBody className="w-full pt-0 mt-10">
                    <div className="overflow-x-auto overscroll-y-auto max-h-96">
                      <table
                        className="table-auto  bg-transparent border-collapse "
                        ref={tableRef}
                      >
                        <thead>
                          {/* <tr>
                            {GetTh("Nomor Purchase Order", 1)}
                            {GetTh("Tanggal", 2)}
                            {GetTh("Tanggal Approval (Ramadhan)", 4)}
                            {GetTh("Tanggal Approval (Jati Munandar)", 4)}
                            {GetTh("Tanggal Approval (Aris Sugiyanto)", 4)}
                            {GetTh("Tanggal Approval (Aldi Harris)", 5)}
                          </tr> */}
                          <tr>
                            {GetTh("MSR Number", 1)}
                            {GetTh("MSR Date", 1)}
                            {GetTh("User MSR", 1)}
                            {GetTh("Bagian", 1)}
                            {GetTh("MSR Subject", 1)}
                            {GetTh("Item Purchase", 1)}
                            {GetTh("Qty", 1)}
                            {GetTh("Owner Estimation Price (Rp)", 1)}
                            {GetTh("User PR", 1)}
                            {GetTh("PO Price (Rp)", 1)}

                            {GetTh("No PO", 1)}
                            {GetTh("Tgl PO", 1)}

                            {GetTh("Tgl Apprv (Rifi)", 1)}
                            {GetTh("Tgl Apprv (Desi)", 1)}
                            {GetTh("Tgl Apprv (Aldi )", 1)}

                            {/* {GetTh("NO. PRC", 1)} */}

                            {/* {GetTh("Kode Barang", 1)} */}

                            {/* {GetTh("Nama Satuan", 1)}
                            {GetTh("Specification", 1)}
                            {GetTh("No. Quatation", 1)}
                            {GetTh("Supplier", 1)}

                            {GetTh("Discount", 1)}
                            {GetTh("PPN", 1)}
                            {GetTh("PPH", 1)}
                            {GetTh("PBBKB", 1)} */}
                          </tr>
                        </thead>
                        <tbody>
                          {mutationData.data &&
                            mutationData.data.data &&
                            [...mutationData.data.data]
                            .sort((a, b) => (b.PurchaseOrderID || "").localeCompare(a.PurchaseOrderID || ""))
                            .map((data, id) => {
                              return (
                                <>
                                  {/* <tr
                                    key={id + "-headder"}
                                    className="bg-gray-100"
                                  >
                                    {GetBody(data.PurchaseOrderID, false, 1)}
                                    {GetBody(
                                      new Date(
                                        substructHour(data.TanggalPO, 7)
                                      ).toLocaleString("en-US", {
                                        weekday: "long",
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric",
                                        hour12: false,
                                      }),
                                      false,
                                      2
                                    )}
                                    {data.Approvals != null
                                      ? GetBody(
                                          getApprovals(data.Approvals, "0"),
                                          false,
                                          4
                                        )
                                      : GetBody("", false, 4)}
                                    {data.Approvals != null
                                      ? GetBody(
                                          getApprovals(data.Approvals, "1"),
                                          false,
                                          4
                                        )
                                      : GetBody("NULL", false, 4)}
                                    {data.Approvals != null
                                      ? GetBody(
                                          getApprovals(data.Approvals, "2"),
                                          false,
                                          4
                                        )
                                      : GetBody("NULL", false, 4)}
                                    {data.Approvals != null
                                      ? GetBody(
                                          getApprovals(data.Approvals, "3"),
                                          false,
                                          5
                                        )
                                      : GetBody("NULL", false, 5)}
                                  </tr> */}
                                  {data.Details ? (
                                    data.Details.map((detail, secondidd) => {
                                      return (
                                        <>
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("A%d", countI), tempData.MPRComparisonID)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("B%d", countI), tempData.PurchaseRequisitionID)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("C%d", countI), parsedTimeS)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("D%d", countI), tempData.NamaBagian)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("E%d", countI), tempData.NamaKaryawan)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("F%d", countI), detail.BarangID)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("F%d", countI), detail.NamaBarang)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("G%d", countI), qty)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("H%d", countI), detail.NamaSatuan)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("I%d", countI), detail.Specification)*/}

                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("J%d", countI), detail.NamaSupplier)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("K%d", countI), tempData.Quotation)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("L%d", countI), detail.Harga)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("M%d", countI), detail.Discount)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("N%d", countI), detail.Ppn)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("O%d", countI), detail.Pph)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("P%d", countI), detail.Pbbkb)*/}
                                          {/*xlsx.SetCellValue(sheet1Name, fmt.Sprintf("Q%d", countI), detail.TotalHarga)*/}

                                          <tr
                                            key={
                                              id + "-" + secondidd + "detail"
                                            }
                                          >
                                            {GetBody(
                                              data.PurchaseRequisitionID,
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              new Date(
                                                data.DatePR
                                              ).toDateString("en-US", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                              }),
                                              false,
                                              1
                                            )}
                                            {GetBody(data.Requester, false, 1)}
                                            {GetBody(data.NamaBagian, false, 1)}
                                            {GetBody(data.Remarks, false, 1)}
                                            {GetBody(
                                              `${detail.BarangID} - ${detail.NamaBarang}`,
                                              false,
                                              1
                                            )}
                                            {GetBody(detail.Qty, false, 1)}

                                            {GetBody(
                                              parseFloat(detail.Harga),
                                              false,
                                              1
                                            )}

                                            {GetBody(
                                              data.NamaKaryawan,
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              parseFloat(detail.TotalHarga),
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              data.PurchaseOrderID,
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              new Date(
                                                substructHour(data.TanggalPO, 7)
                                              ).toLocaleString("en-US", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                                hour: "numeric",
                                                minute: "numeric",
                                                second: "numeric",
                                                hour12: false,
                                              }),
                                              false,
                                              1
                                            )}
                                            {data.Approvals != null
                                              ? GetBody(
                                                  getApprovals(
                                                    data.Approvals,
                                                    "0"
                                                  ),
                                                  false,
                                                  1
                                                )
                                              : GetBody("", false, 1)}
                                            {data.Approvals != null
                                              ? GetBody(
                                                  getApprovals(
                                                    data.Approvals,
                                                    "1"
                                                  ),
                                                  false,
                                                  1
                                                )
                                              : GetBody("", false, 1)}
                                            {data.Approvals != null
                                              ? GetBody(
                                                  getApprovals(
                                                    data.Approvals,
                                                    "2"
                                                  ),
                                                  false,
                                                  1
                                                )
                                              : GetBody("", false, 1)}

                                            {/* {GetBody(
                                              data.MPRComparisonID,
                                              false,
                                              1
                                            )} */}

                                            {/* {GetBody(detail.BarangID, false, 1)} */}

                                            {/* {GetBody(
                                              detail.NamaSatuan,
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              detail.Specification,
                                              false,
                                              1
                                            )}
                                            {GetBody(data.Quotation, false, 1)}
                                            {GetBody(
                                              detail.NamaSupplier,
                                              false,
                                              1
                                            )}

                                            {GetBody(
                                              parseFloat(detail.Discount),
                                              true,
                                              1
                                            )}
                                            {GetBody(
                                              parseFloat(detail.Ppn),
                                              true,
                                              1
                                            )}
                                            {GetBody(
                                              parseFloat(detail.Pph),
                                              true,
                                              1
                                            )}
                                            {GetBody(
                                              parseFloat(detail.Pbbkb),
                                              true,
                                              1
                                            )} */}
                                          </tr>
                                        </>
                                      );
                                    })
                                  ) : (
                                    <>
                                      <tr
                                        key={
                                          id +
                                          "-" +
                                          data.MPRComparisonID +
                                          "detail"
                                        }
                                      >
                                        {GetBody(
                                          data.MPRComparisonID,
                                          false,
                                          1
                                        )}
                                        {GetBody(
                                          data.PurchaseRequisitionID,
                                          false,
                                          1
                                        )}
                                        {GetBody(
                                          new Date(data.DatePR).toDateString(
                                            "en-US",
                                            {
                                              weekday: "long",
                                              year: "numeric",
                                              month: "long",
                                              day: "numeric",
                                            }
                                          ),
                                          false,
                                          1
                                        )}
                                        {GetBody(data.NamaBagian, false, 1)}
                                        {GetBody(data.Requester, false, 1)}
                                        {GetBody(data.NamaKaryawan, false, 1)}
                                        {GetBody(data.Remarks, false, 1)}
                                        {GetBody("", false, 1)}
                                        {GetBody("", false, 1)}
                                        {GetBody("", false, 1)}
                                        {GetBody("", false, 1)}
                                        {GetBody("", false, 1)}
                                        {GetBody(data.Quotation, false, 1)}
                                        {GetBody("", false, 1)}
                                        {GetBody(parseFloat(0), true, 1)}
                                        {GetBody(parseFloat(0), true, 1)}
                                        {GetBody(parseFloat(0), true, 1)}
                                        {GetBody(parseFloat(0), true, 1)}
                                        {GetBody(parseFloat(0), true, 1)}
                                        {GetBody(
                                          parseFloat(0).toLocaleString(),
                                          true,
                                          1
                                        )}
                                      </tr>
                                    </>
                                  )}
                                </>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportPurchaseOrder;
